/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membersdecline1Inputs */

const en_membersdecline1 = /** @type {(inputs: Membersdecline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decline`)
};

const de_membersdecline1 = /** @type {(inputs: Membersdecline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ablehnen`)
};

/**
* | output |
* | --- |
* | "Decline" |
*
* @param {Membersdecline1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const membersdecline1 = /** @type {((inputs?: Membersdecline1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membersdecline1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_membersdecline1(inputs)
	return de_membersdecline1(inputs)
});
export { membersdecline1 as "membersDecline" }